"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPredicateIndexFinder;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _getLength = _interopRequireDefault(require("./_getLength.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function (array, predicate, context) {
    predicate = (0, _cb.default)(predicate, context);
    var length = (0, _getLength.default)(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}